import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import deepmerge from 'deepmerge';
var densityToTypeSizePaletteIndex = {
  touch: 70,
  low: 60,
  medium: 50,
  high: 40
};

var createActionTextStyle = function createActionTextStyle(typography, density, variant) {
  return _assign({
    letterSpacing: 0.6,
    fontSize: "".concat(typography.size[densityToTypeSizePaletteIndex[density]], "px"),
    lineHeight: typography.lineHeight
  }, typography.getFace(variant === 'secondary' ? 'semiBold' : 'bold'), {
    textTransform: 'uppercase'
  });
};

var createRegular = function createRegular(_ref) {
  var palette = _ref.palette,
      typography = _ref.typography;
  var type = palette.type,
      grey40 = palette.grey40,
      grey60 = palette.grey60,
      grey80 = palette.grey80,
      grey200 = palette.grey200,
      grey300 = palette.grey300,
      grey900 = palette.grey900,
      white = palette.white;

  var createActionDensity = function createActionDensity(density) {
    if (type === 'light') {
      return {
        "default": _assign({
          color: grey900,
          background: grey60,
          icon: grey900
        }, createActionTextStyle(typography, density, 'regular')),
        active: {
          background: grey200,
          color: white,
          icon: white
        },
        hover: {
          background: grey40,
          color: grey900,
          icon: grey900
        }
      };
    }

    return {
      "default": _assign({
        color: white,
        background: grey300,
        icon: white
      }, createActionTextStyle(typography, density, 'regular')),
      active: {
        background: grey80,
        color: grey900,
        icon: grey900
      },
      hover: {
        background: grey200,
        color: white,
        icon: white
      }
    };
  };

  return {
    touch: createActionDensity('touch'),
    low: createActionDensity('low'),
    medium: createActionDensity('medium'),
    high: createActionDensity('high')
  };
};

var createCTA = function createCTA(_ref2) {
  var palette = _ref2.palette,
      typography = _ref2.typography;
  var blue500 = palette.blue500,
      blue600 = palette.blue600,
      blue700 = palette.blue700,
      white = palette.white;

  var createActionDensity = function createActionDensity(density) {
    return {
      "default": _assign({
        background: blue600,
        color: white,
        icon: white
      }, createActionTextStyle(typography, density, 'CTA')),
      active: {
        background: blue700,
        color: white,
        icon: white
      },
      hover: {
        background: blue500,
        color: white,
        icon: white
      }
    };
  };

  return {
    touch: createActionDensity('touch'),
    low: createActionDensity('low'),
    medium: createActionDensity('medium'),
    high: createActionDensity('high')
  };
};

var createSecondary = function createSecondary(_ref3) {
  var palette = _ref3.palette,
      typography = _ref3.typography;
  var type = palette.type,
      grey40 = palette.grey40,
      grey60 = palette.grey60,
      grey80 = palette.grey80,
      grey200 = palette.grey200,
      grey300 = palette.grey300,
      grey900 = palette.grey900,
      white = palette.white;

  var createActionDensity = function createActionDensity(density) {
    if (type === 'light') {
      return {
        "default": _assign({
          background: 'none',
          color: grey900,
          icon: grey300
        }, createActionTextStyle(typography, density, 'secondary')),
        active: {
          background: grey200,
          color: white,
          icon: white
        },
        hover: {
          background: grey40,
          color: grey900,
          icon: grey300
        }
      };
    }

    return {
      "default": _assign({
        background: 'none',
        color: white,
        icon: grey60
      }, createActionTextStyle(typography, density, 'secondary')),
      active: {
        background: grey80,
        color: grey900,
        icon: grey900
      },
      hover: {
        background: grey200,
        color: white,
        icon: white
      }
    };
  };

  return {
    touch: createActionDensity('touch'),
    low: createActionDensity('low'),
    medium: createActionDensity('medium'),
    high: createActionDensity('high')
  };
};

var createActionVariants = function createActionVariants(options) {
  var variants = {};
  var keys = Object.keys(options);

  for (var i = 0; i < keys.length; i++) {
    variants[keys[i]] = keys[i];
  }

  return variants;
};

var createGetAction = function createGetAction(options) {
  return function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$variant = _ref4.variant,
        variant = _ref4$variant === void 0 ? 'regular' : _ref4$variant,
        _ref4$density = _ref4.density,
        density = _ref4$density === void 0 ? 'medium' : _ref4$density;

    var hasOwnProperty = Object.prototype.hasOwnProperty;

    if (!hasOwnProperty.call(options, variant) || !hasOwnProperty.call(options[variant], density)) {
      return {};
    }

    return options[variant][density];
  };
};

export var createAction = function createAction(palettes) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref5 = typeof action === 'function' ? action(palettes) : action,
      otherGetAction = _ref5.getAction,
      otherOptions = _objectWithoutProperties(_ref5, ["getAction"]);

  var options = {
    cta: createCTA(palettes),
    regular: createRegular(palettes),
    secondary: createSecondary(palettes)
  };
  var mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return _assign({
    getAction: otherGetAction || createGetAction(mergedOptions),
    actionVariants: createActionVariants(options)
  }, mergedOptions);
};